var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotoneraMaquina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2966_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8425 18.788L36.7425 22.568L31.5 17.3255V14.1755L36.7425 8.93297L44.8425 12.713C45.6975 13.118 46.6875 12.7355 47.0925 11.903C47.4975 11.048 47.115 10.058 46.2825 9.65297L37.4625 5.53547C36.6075 5.13047 35.595 5.31047 34.92 5.98547L31.005 9.90047C30.6 9.36047 29.97 9.00047 29.25 9.00047C28.0125 9.00047 27 10.013 27 11.2505V13.5005H19.845C18.9 10.8905 16.425 9.00047 13.5 9.00047C9.765 9.00047 6.75 12.0155 6.75 15.7505C6.75 18.2255 8.1 20.363 10.08 21.5555L15.93 40.5005H13.5C11.025 40.5005 9 42.5255 9 45.0005V47.2505H38.25V45.0005C38.25 42.5255 36.225 40.5005 33.75 40.5005H30.105L18.9225 19.733C19.305 19.193 19.62 18.6305 19.845 18.0005H27V20.2505C27 21.488 28.0125 22.5005 29.25 22.5005C29.97 22.5005 30.6 22.1405 31.005 21.6005L34.92 25.5155C35.595 26.1905 36.6075 26.3705 37.4625 25.9655L46.2825 21.848C47.1375 21.443 47.4975 20.453 47.0925 19.598C46.6875 18.7655 45.6975 18.383 44.8425 18.788ZM13.5 18.0005C12.2625 18.0005 11.25 16.988 11.25 15.7505C11.25 14.513 12.2625 13.5005 13.5 13.5005C14.7375 13.5005 15.75 14.513 15.75 15.7505C15.75 16.988 14.7375 18.0005 13.5 18.0005ZM24.9975 40.5005H20.6325L15.0975 22.5005H15.3225L24.9975 40.5005Z",
    fill: "#EDF0F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2966_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotoneraMaquina);
export default __webpack_public_path__ + "static/media/botoneraMaquina.e0bf4af7fc8629e553917dd4983627a9.svg";
export { ForwardRef as ReactComponent };